module.exports = __webpack_public_path__ + "img/aai_logo_CMYK_turquoise_black.b8f5956e.svg";